<div class="row">
	<div class="col-md-9">
		<div class="row">
			<br><br>
			<div class="col-md-6" style="float:left;">
				<b
					*ngIf="domainUrl && !iframeLoader"
					style="font-size:20px;"
				>
					{{ 'adminstat.common.Site' | translate }}:
					
					<a [href]="safeUrl" target="_blank" rel="noreferrer">{{ domainUrl }}</a>
				</b>
				
				<div class="alert alert-warning" role="alert">
					Если вместо сайта показывает 403 - нужно отдельно авторизоваться на <a href="https://ukit.com">ukit</a>
				</div>
				
				<b
					*ngIf="!domainUrl && !iframeLoader"
					style="font-size:20px;"
				>
					{{ 'adminstat.support.accessor.No available sites' | translate }}!
				</b>
			</div>

			<ng-container
				*ngIf="userRoles.indexOf('admin') != -1 || userRoles.indexOf('mainManager') != -1 || userRoles.indexOf('curator') != -1"
			>
				<div class="col-md-2" style="float:right;">
					<button type="button" class="btn btn-primary" (click)="siteSearch()">
						<b>{{ 'adminstat.support.accessor.site search' | translate }}</b>
					</button>
				</div>
				
				<div class="col-md-2" style="float:right;">
					<button type="button" class="btn btn-primary" (click)="showDetails()">
						<b>{{ 'adminstat.support.accessor.stats' | translate }}</b>
					</button>
				</div>
				
				<div class="col-md-2" style="float:right;">
					<button type="button" class="btn btn-primary" (click)="manage()">
						<b>{{ 'adminstat.common.Manage' | translate }}</b>
					</button>
				</div>
			</ng-container>
		</div>

		<loading [isLoad]="iframeLoader"></loading>
		<div *ngIf="url && !iframeLoader" id="IframeWrapper" style="position: relative;">
			<div id="iframeBlocker"></div>
			<iframe [src]="safeUrl" name="iframe" scrolling="auto" frameborder="0" (load)="onload()" [style.width.%]="100" [style.height.px]="height"></iframe>
		</div>
	</div>

	<div class="col-md-3">
		<div class="row">
			<table class="table">
				<tr>
					<td>
						{{ 'adminstat.support.accessor.viewed by me' | translate }}:
					</td>

					<td>
						<loading [isLoad]="mainLoader"></loading>
						<button-anhor (click)="showMyEditSites('edit')" *ngIf="!mainLoader">
							{{ editCount }}
						</button-anhor>
					</td>
				</tr>

				<tr>
					<td>
						{{ 'adminstat.support.accessor.defer by me' | translate }}:
					</td>

					<td>
						<loading [isLoad]="mainLoader"></loading>
						<button-anhor (click)="showMyEditSites('defer')" *ngIf="!mainLoader">
							{{ deferCount }}
						</button-anhor>
					</td>
				</tr>

				<tr>
					<td>
						{{ 'adminstat.support.accessor.totalSiteCount' | translate }}:
					</td>

					<td>
						<loading [isLoad]="mainLoader"></loading>
						<p *ngIf="!mainLoader">{{ totalCount }}</p>
					</td>
				</tr>
			</table>
		</div>

		<br><hr>

		<p>Установите категорию</p>
		
		<ng-selectize
				[config]="selectize.config"
				[options] = "selectize.options"
				[(ngModel)]="selectizeTitle"
				(ngModelChange)="changeSiteCategory($event)"
		>
		</ng-selectize>
		
		<br>
		
		<div class="row">
			<div class="col-md-5">
				<button type="button" class="btn btn-danger" style="width: 100px;" (click)="setCategory(1)">
					<b>{{ 'adminstat.support.accessor.defer' | translate }}</b>
				</button>
			</div>

			<div class="col-md-5">
				<button type="button" class="btn btn-success" style="width: 100px;" (click)="setCategory(0)">
					<b>Save</b>
				</button>
			</div>

			<div class="col-md-2">
				<div class="form-check">
					<input type="checkbox" class="form-check-input" id="topSite" [(ngModel)]="topSite">
					<label class="form-check-label" for="topSite">TOP site</label>
				</div>
			</div>
		</div>

		<hr>
	</div>
</div>
